import React from 'react';
import { useTranslation } from 'react-i18next';
import './CreditCard.scss';

// Import SVG assets
import creditCardBlue from '../../assets/images/credit_card_blue.svg';
import creditCardSilver from '../../assets/images/credit_card_silver.svg';
import creditCardGold from '../../assets/images/credit_card_golden.svg';
import creditCardPlatinum from '../../assets/images/credit_card_platinum.svg';
import { CreditCardTier } from 'types/dto/profile';


export interface CreditCardProps {
  tier: CreditCardTier;
  tierTitle: string;
  validThru?: string;
  className?: string;
  height?: string;
}

const CreditCard: React.FC<CreditCardProps> = ({
  tier,
  tierTitle,
  validThru,
  className = '',
  height
}) => {
  const { t } = useTranslation('creditCard');

  // Map tier to background image
  const getBackgroundImage = (tier: CreditCardTier): string => {
    switch (tier) {
    case 'blue':
      return creditCardBlue;
    case 'silver':
      return creditCardSilver;
    case 'gold':
      return creditCardGold;
    case 'platinum':
      return creditCardPlatinum;
    default:
      return creditCardBlue;
    }
  };


  const backgroundImage = getBackgroundImage(tier);

  // Prepare style object
  const cardStyle: React.CSSProperties = { backgroundImage: `url(${backgroundImage})` };

  // Add height if provided
  if (height) {
    cardStyle.height = height;
  }

  return (
    <div
      className={`credit-card ${className}`}
      style={cardStyle}
    >
      {/* Card Header */}
      <div className="credit-card__header">
        <div className="credit-card__brand">
          {t('brand')}
        </div>
      </div>


      {/* Card Footer */}
      <div className="credit-card__footer">
        <div className="credit-card__tier">
          {tierTitle}
        </div>

        {validThru && (
          <div className="credit-card__expiry">
            <span className="credit-card__label">
              {t('validThru')}
            </span>
            <span className="credit-card__value">
              {validThru}
            </span>
          </div>
        )}


      </div>
    </div>
  );
};

export default CreditCard;